import { useState, useEffect } from 'react';
import './header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="Home-section">
      <div className={`Header ${scrolled ? 'scrolled' : ''}`}>
        <div className="brand">
          <h2>
            <span className="brand-accent">&lt;</span>DM
            <span className="brand-accent">/&gt;</span>
          </h2>
        </div>

        <button
          className={`menu-toggle ${isOpen ? 'active' : ''}`}
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-link ${isOpen ? 'open' : ''}`}>
          <ul>
            <li><a href="#Home" onClick={closeMenu}>Home</a></li>
            <li><a href="#About" onClick={closeMenu}>About</a></li>
            <li><a href="#Skills" onClick={closeMenu}>Skills</a></li>
            <li><a href="#Projects" onClick={closeMenu}>Projects</a></li>
            <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Header;
